import { Tooltip, Typography } from '@mui/material';
import cn from 'classnames';
import { format, parseISO } from 'date-fns';

import styles from './FormItem.module.css';

interface ValueProps {
    content?: string;
    className?: string;
    includeTooltip?: boolean;
}

const DATE_FORMAT = 'LLLL d, yyyy';

function parseValue(content: string = '-') {
    const formatted = content.replace('_', ' ');
    try {
        const parsedDate = parseISO(formatted);
        return format(parsedDate, DATE_FORMAT);
    } catch {
        return formatted;
    }
}

export const Value = ({ content, className, includeTooltip }: ValueProps) => {
    const value = parseValue(content);

    return includeTooltip ? (
        <Tooltip title={value}>
            <Typography className={cn(styles.value, className)}>{value}</Typography>
        </Tooltip>
    ) : (
        <Typography className={cn(styles.value, className)}>{value}</Typography>
    );
};
